export const FREE_TRIAL_DAYS = 7;
export const DATE_FORMAT_1 = "MMM dd yyyy";
